"use client";

import { cn } from "utils";
import { PortfolioInsightErrorCircleIcon } from "./PortfolioInsightErrorCircleIcon";
import type { PortfolioInsightItem } from "./types";

interface PortfolioInsightAlertCardProps {
  item: PortfolioInsightItem;
  className?: string;
  "data-testid"?: string;
}

/** H5 · Figma 88972:41497 — accent2 alert block */
export const PortfolioInsightAlertCard: React.FC<
  PortfolioInsightAlertCardProps
> = ({ item, className, "data-testid": testId }) => {
  return (
    <article
      className={cn(
        "flex flex-col gap-2 rounded-3 bg-background_accent2_overlay10 p-2",
        className,
      )}
      data-testid={testId ?? "portfolio-insight-card-view"}
      data-variant="alert"
    >
      <div className="flex items-center gap-1 px-2">
        <PortfolioInsightErrorCircleIcon data-testid="portfolio-insight-error-icon-card" />
        <h3 className="title_l text-content_primary">{item.title}</h3>
      </div>
      <div className="rounded-2 bg-background_solid_neutral_primary p-2">
        <p className="body_m text-content_primary">{item.body}</p>
      </div>
    </article>
  );
};
